module.exports = __webpack_public_path__ + "static/RamadanJashriPhDBELGIUM-ba29b0b8e3ebb67a6956f2a4a304eeae.jpg";